import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { stringify } from 'hub-http/helpers/params';
import I18n from 'I18n';
import * as OfferingType from 'marketplace-ui-common/offerings/constants/OfferingType';
import { ecosystemAppClient, ecosystemPublicClient } from 'marketplace-ui-common/clients/ecosystemClient';
import { TYPEAHEAD_SEARCH_RESULTS_LIMIT } from 'marketplace-ui-common/constants/search';
import AssetSearchBarResult from '../components/AssetSearchBarResult';
import { getModuleMarketplaceUrl, getTemplateMarketplaceUrl, getThemeMarketplaceUrl } from '../../utils/urls';
export const VIEW_ALL_THEMES = '__VIEW_ALL_THEMES__';
export const VIEW_ALL_MODULES = '__VIEW_ALL_MODULES__';
export function useAssetSearchBarQuery({
  appContext = 'app',
  grouped = false,
  limit = TYPEAHEAD_SEARCH_RESULTS_LIMIT,
  offeringType = 'THEME'
} = {}) {
  const offeringTypeIsModule = offeringType === OfferingType.MODULE || Array.isArray(offeringType) && offeringType.length === 1 && offeringType.includes('MODULE');
  const searchBarGroupLabelMessage = I18n.text('marketplace-ui-assets-core.assets.offeringsSearchBarGroupLabel');
  const searchUrl = 'assets/search';
  const VIEW_ALL_ASSETS = '__VIEW_ALL_ASSETS__';
  const getAssetDetailsUrl = useCallback((_offeringType, pathname) => {
    return _offeringType === 'MODULE' ? getModuleMarketplaceUrl(appContext, pathname) : getThemeMarketplaceUrl(appContext, pathname);
  }, [appContext]);
  const getViewAllUrl = useCallback(input => {
    const query = stringify({
      eco_search: input
    });
    return getTemplateMarketplaceUrl(appContext, `search?${query}`);
  }, [appContext]);
  const getSearchBarViewAllLabelMessage = useCallback(total => {
    if (offeringTypeIsModule) {
      return I18n.text('marketplace-ui-assets-core.assets.moduleSearchBarViewAll', {
        total
      });
    }

    return I18n.text('marketplace-ui-assets-core.assets.offeringsSearchBarViewAll', {
      total
    });
  }, [offeringTypeIsModule]);
  const fetcher = useCallback(input => {
    const client = appContext === 'public' ? ecosystemPublicClient : ecosystemAppClient;
    const data = {
      limit,
      search: input,
      offeringType: ['MODULE', 'THEME']
    };
    const response = client.post(searchUrl, {
      data
    });
    return response.then(res => {
      return res;
    }).then(({
      items,
      total
    }) => {
      const options = items.map(item => {
        const {
          companyName,
          name,
          offeringId,
          offeringType: _offeringType,
          slug,
          thumbnailUrl
        } = item;
        const offering = _offeringType === 'MODULE' ? 'module' : 'theme';
        return {
          dropdownText: /*#__PURE__*/_jsx(AssetSearchBarResult, {
            companyName: companyName,
            name: name,
            offeringType: _offeringType,
            thumbnailUrl: thumbnailUrl
          }),
          href: getAssetDetailsUrl(_offeringType, slug),
          item,
          linkUse: 'unstyled',
          text: name,
          value: `${offering}::${offeringId}`,
          slug
        };
      });

      if (total > limit) {
        options.push({
          href: getViewAllUrl(input),
          text: getSearchBarViewAllLabelMessage(total),
          value: VIEW_ALL_ASSETS,
          slug: `search?${stringify({
            eco_search: input
          })}`
        });
      }

      return options;
    }).then(options => grouped ? [{
      text: searchBarGroupLabelMessage,
      options
    }] : options);
  }, [appContext, getAssetDetailsUrl, getSearchBarViewAllLabelMessage, getViewAllUrl, grouped, limit, searchBarGroupLabelMessage, searchUrl, VIEW_ALL_ASSETS]);
  return fetcher;
}